import { useEffect, useState } from 'react'
import { Outlet, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AsideDefault } from './components/aside/AsideDefault'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { PageDataProvider } from './core'
import { useLocation } from 'react-router-dom'
import { ThemeModeProvider } from '../partials'
import { MenuComponent } from '../assets/ts/components'
import { Toolbar } from './components/toolbar/Toolbar'
import { checkToken, checkTokenV2, loginAs } from '../../api/modules/auth'
import { useDispatch } from 'react-redux'
import { setAuthUser, setCredential, setMenu } from 'src/redux/slices/authSlices'
import { useAppDispatch } from 'src/redux/hooks'
import { setToken } from '../redux/content'
import swal from 'sweetalert'
import { useTranslation } from 'react-i18next'

const MasterLayout = () => {
  const [loading, setLoading] = useState(false)
  const dispath = useDispatch()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [params] = useSearchParams();

  const location = useLocation()
  const {t} = useTranslation();

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
    localStorage.removeItem('user-segment')
    localStorage.removeItem('user-product-type')
    localStorage.removeItem('sector_ids')
    localStorage.removeItem('user_code')
  }

  const refreshToken = async () => {

    const paramToken =  params.get('token');
    const token = paramToken ?? localStorage.getItem('token');

    await checkTokenV2(token)
      .then((resp: any) => {

        const data = resp.data.data
        data.token = token ?? ''

        if (paramToken){
          removeStorage()
          setUserCredential(data)
        } 
        dispatch(setMenu(data.accesses.role_accesses))
        dispatch(setCredential(data.credential))
        dispath(setToken(token))

      }).catch((err: any) => {

        swal({
          title: 'Error',
          text: t('invalid-session')
        });
        removeStorage()
        navigate('/auth')

      })

  }

  const setUserCredential = (data: any) => {
    const credentialBase64Decode = atob(data?.credential)
    const credentialJSON = JSON.parse(credentialBase64Decode)
    
    localStorage.setItem('token', data?.token)
    localStorage.setItem('role-flag', credentialJSON.role_flag)
    localStorage.setItem('user_code', credentialJSON.username)
    localStorage.setItem('role_flagg', credentialJSON.role_flag)
    localStorage.setItem('sector_ids', credentialJSON.sector_ids)
    localStorage.setItem('email', credentialJSON.email)
    localStorage.setItem('user-id', credentialJSON.user_id)
    localStorage.setItem('cust-code', credentialJSON.customer_code)
    localStorage.setItem('cus-grup', credentialJSON.customer_account_group)
    localStorage.setItem('cus-grupp', credentialJSON.customer_account_group)
    localStorage.setItem('cust-group', credentialJSON.customer_account_group)
    localStorage.setItem('user-segment', credentialJSON.segments)
    localStorage.setItem('user-product-type', credentialJSON.product_types)
    localStorage.setItem('credential', data?.credential)
    localStorage.setItem('credential-decoded', data?.credential)
    localStorage.setItem('accesses', JSON.stringify(data?.accesses))
    localStorage.setItem('access', JSON.stringify(data?.accesses.role_accesses))
    localStorage.setItem('username', credentialJSON.customer?.title != null
        ? credentialJSON.customer?.title + ' ' + credentialJSON.customer?.name
        : credentialJSON.name
    )    
  }

  useEffect(() => {
    refreshToken()
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    refreshToken()
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  const [userId, setUserId] = useState<string>('')
  useEffect(() => {
    setUserId(localStorage.getItem('impersonating_user_id') || '')
  }, []);

  const [loadingImpersonate, setLoadingImpersonate] = useState(false)
  const logoutImpersonate = async () => {
    if(loadingImpersonate) return
    setLoadingImpersonate(true)
    await loginAs(userId)
      .then(({data: resp}) => {
        if (!resp.data.error) {
          localStorage.removeItem('impersonating_user_id')
          dispatch(setAuthUser(resp.data))
          localStorage.setItem('role-flag', resp.data.credential.role_flag)
          localStorage.setItem('user_code', resp.data.credential.username)
          localStorage.setItem('role_flagg', resp.data.credential.role_flag)
          localStorage.setItem('sector_ids', resp.data.credential.sector_ids)
          localStorage.setItem('email', resp.data.credential.email)
          // localStorage.setItem('name', resp.data.credential.name)
          if (resp.data.credential.role_flag == null)
            localStorage.setItem(
              'username',
              resp.data.credential.customer?.title != null
                ? resp.data.credential.customer?.title + ' ' + resp.data.credential.customer?.name
                : resp.data.credential.customer?.name
            )
          else localStorage.setItem('username', resp.data.credential.name)
          localStorage.setItem('user-id', resp.data.credential.user_id)
          localStorage.setItem('cust-code', resp.data.credential.customer_code)
          localStorage.setItem('cus-grup', resp.data.credential.customer_account_group)
          localStorage.setItem('cus-grupp', resp.data.credential.customer_account_group)
          localStorage.setItem('cust-group', resp.data.credential.customer_account_group)
          localStorage.setItem('user-segment', resp.data.credential.segments)
          localStorage.setItem('user-product-type', resp.data.credential.product_types)
  
          if (!resp.data.error) {
            localStorage.setItem('token', resp.data.access_token)
            checkToken(resp.data.access_token).then((res) => {
              dispatch(setCredential(res.data.credential))
              try{
                const test = atob(resp.data.credential)
                const temp = JSON.parse(test)
                localStorage.setItem('credential', test)
                localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
                localStorage.setItem('credential-decoded', test)
              }catch(e){}
            })
            if (!resp.data.accesses) {
              // console.log('ga punya')
            } else {
              localStorage.setItem('access', JSON.stringify(resp.data.accesses.role_accesses))
              localStorage.setItem('accesses', JSON.stringify(resp.data.accesses))
              // dispath(setAccesses(JSON.stringify(resp.data.accesses.role_accesses)))
            }
            dispath(setToken(resp.data.access_token))
            navigate('/dashboard')
        }
      }
    })
      .catch((error) => {
        swal({
          title: error.response?.data?.message || error.message,
          icon: 'error',
        })
      })
      .finally(() => {
        setLoadingImpersonate(false)
      })
  }

  return (
    <>
      {loading ? '' :
        <PageDataProvider>
          <ThemeModeProvider>
            <div className='page d-flex flex-row flex-column-fluid'>
              <AsideDefault />
              <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                <HeaderWrapper />

                <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                  <Toolbar />
                  <div className='post d-flex flex-column-fluid' id='kt_post'>
                    <Content>
                      <Outlet />
                    </Content>
                  </div>
                </div>
              </div>
            </div>
            <ScrollTop />

            { userId && <div className='p-4 text-white text-end' style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 666, backgroundColor: 'red' }}>
              Anda sedang dalam mode Impersonate. <a onClick={logoutImpersonate} href='javacript:void(0)' className='font-weight-bold text-underline'>
                 {
                  loadingImpersonate ? 'Loading...' : 'Kembali ke akun asli'
                 }
                </a>
            </div> }
          </ThemeModeProvider>
        </PageDataProvider>
      }
    </>

  )
}

export { MasterLayout }
